(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('.hero__content-wrapper');
    if (!wrapper) return;

    const removeClearFix = () => {
      wrapper.querySelectorAll(':scope > div[style]').forEach((node) => {
        const style = node.getAttribute('style') || '';
        if (/clear\s*:\s*both/i.test(style) && node.childElementCount === 0 && !node.textContent.trim()) {
          node.remove();
        }
      });
    };

    removeClearFix();
    new MutationObserver(removeClearFix).observe(wrapper, { childList: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-image-scroll-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SEL = (root, q) => root.querySelector(q);
    const SEL_ALL = (root, q) => root.querySelectorAll(q);

    /**
     * The aside is built in the section; Shopify can leave settings.image blank there even when
     * the D2C scroll content block has an image. Each [data-sist-panel] carries the real URL from the block.
     */
    function syncD2cSistDesktopAside(sectionEl) {
      const mql = window.matchMedia('(min-width: 768px)');
      if (!mql.matches) return;

      const assets = Array.from(SEL_ALL(sectionEl, '[data-sist-asset]'));
      const panels = Array.from(SEL_ALL(sectionEl, '[data-sist-panel]'));
      if (!assets.length || !panels.length) return;

      for (let i = 0; i < panels.length; i++) {
        const panel = panels[i];
        const asset = assets[i];
        if (!asset || !panel) continue;

        const usePh = panel.getAttribute('data-sist-desk-placeholder') === 'true';
        const url = (panel.getAttribute('data-sist-desk-image') || '').trim();
        if (usePh || !url) continue;

        const alt = panel.getAttribute('data-sist-desk-alt') || 'Image';
        const hadPh = asset.classList.contains('d2c-sist__asset--placeholder');
        if (!hadPh) {
          const existing = asset.querySelector('img.d2c-sist__img');
          if (existing && existing.getAttribute('src') === url) continue;
        }

        asset.classList.remove('d2c-sist__asset--placeholder');
        asset.setAttribute('aria-hidden', 'false');
        asset.innerHTML = '';
        const img = document.createElement('img');
        img.className = 'd2c-sist__img';
        img.src = url;
        img.alt = alt;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.sizes = '(min-width: 768px) 45vw, 100vw';
        img.setAttribute('data-synced', '1');
        asset.appendChild(img);
      }
    }

    function getTriggerY() {
      return Math.max(0, window.innerHeight * 0.28);
    }

    /**
     * Sticky aside frame is driven by the active D2C scroll content panel (block settings).
     */
    function applyAsideInnerRatio(sectionEl, panelEl) {
      const inner = SEL(sectionEl, '[data-d2c-sist-aside-inner]');
      if (!inner || !panelEl) return;

      const ar = panelEl.getAttribute('data-sist-sticky-ar') || 'auto';
      const w = panelEl.getAttribute('data-sist-sticky-ar-w');
      const h = panelEl.getAttribute('data-sist-sticky-ar-h');
      const fit = panelEl.getAttribute('data-sist-sticky-fit') || 'cover';
      const useRatio = ar !== 'auto' && w && h;

      inner.classList.toggle('d2c-sist__aside-inner--ratio', useRatio);
      if (useRatio) {
        inner.style.setProperty('--d2c-sist-ar-w', w);
        inner.style.setProperty('--d2c-sist-ar-h', h);
        inner.style.setProperty('--d2c-sist-object-fit', fit);
      } else {
        inner.style.removeProperty('--d2c-sist-ar-w');
        inner.style.removeProperty('--d2c-sist-ar-h');
        inner.style.removeProperty('--d2c-sist-object-fit');
      }
    }

    function updateSection(sectionEl) {
      const mql = window.matchMedia('(min-width: 768px)');
      if (!mql.matches) return;

      const assets = Array.from(SEL_ALL(sectionEl, '[data-sist-asset]'));
      const panels = Array.from(SEL_ALL(sectionEl, '[data-sist-panel]'));
      if (!assets.length || !panels.length) return;

      let active = 0;
      const y = getTriggerY();
      for (let i = 0; i < panels.length; i++) {
        const t = panels[i].getBoundingClientRect().top;
        if (t < y) {
          active = i;
        }
      }
      active = Math.min(active, assets.length - 1);
      for (let j = 0; j < assets.length; j++) {
        const on = j === active;
        assets[j].classList.toggle('is-active', on);
      }
      applyAsideInnerRatio(sectionEl, panels[active]);
    }

    function parseD2cSistCounterTarget(s) {
      if (!s) return null;
      const t = String(s).trim();
      const m = t.match(/^(.*?)(\d[\d,]*\.?\d*)(.*)$/);
      if (!m) return null;
      const before = m[1] != null ? m[1] : '';
      const numRaw = m[2].replace(/,/g, '');
      const after = m[3] != null ? m[3] : '';
      const n = parseFloat(numRaw);
      if (Number.isNaN(n)) return null;
      const dec = (numRaw.split('.')[1] || '').length;
      const useCommas = m[2].includes(',');
      return { before, after, n, dec, useCommas, full: t };
    }

    function formatD2cSistCounterValue(p, v) {
      if (p.dec > 0) {
        return p.before + v.toFixed(p.dec) + p.after;
      }
      if (p.useCommas) {
        return p.before + Math.round(v).toLocaleString('en-US') + p.after;
      }
      return p.before + String(Math.round(v)) + p.after;
    }

    function runD2cSistCounterAnimation(el, p) {
      const duration = 3000;
      const t0 = performance.now();
      function easeOutCubic(t) {
        return 1 - (1 - t) * (1 - t) * (1 - t);
      }
      el.textContent = formatD2cSistCounterValue(p, 0);
      function step(now) {
        const t = Math.min(1, (now - t0) / duration);
        const v = p.n * easeOutCubic(t);
        el.textContent = formatD2cSistCounterValue(p, t < 1 ? v : p.n);
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = p.full;
        }
      }
      requestAnimationFrame(step);
    }

    /**
     * Matches IntersectionObserver options below: root = viewport, rootMargin bottom -6%,
     * threshold 0.1 (at least 10% of the element area inside the root rect).
     */
    function d2cSistCounterIsAlreadyRevealed(el) {
      const vh = window.innerHeight;
      const vw = window.innerWidth;
      const rootTop = 0;
      const rootLeft = 0;
      const rootRight = vw;
      const rootBottom = vh * 0.94;
      const r = el.getBoundingClientRect();
      const ih = Math.max(0, Math.min(r.bottom, rootBottom) - Math.max(r.top, rootTop));
      const iw = Math.max(0, Math.min(r.right, rootRight) - Math.max(r.left, rootLeft));
      const inter = ih * iw;
      const area = r.width * r.height;
      if (area <= 0) return false;
      return inter / area >= 0.1;
    }

    function initD2cSistCounterAnimations(sectionEl) {
      const els = Array.from(SEL_ALL(sectionEl, '[data-d2c-sist-counter-value]'));
      if (!els.length) return;

      function tryStartCounter(el) {
        if (el.getAttribute('data-d2c-sist-counter-animated') === '1') return;
        const target = el.getAttribute('data-d2c-sist-counter-target') || el.textContent || '';
        const parsed = parseD2cSistCounterTarget(target);
        el.setAttribute('data-d2c-sist-counter-animated', '1');
        io.unobserve(el);
        if (!parsed) return;
        if (parsed.n === 0) {
          el.textContent = parsed.full;
          return;
        }
        runD2cSistCounterAnimation(el, parsed);
      }

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            tryStartCounter(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
      );

      els.forEach((el) => {
        if (el.getAttribute('data-d2c-sist-counter-animated') === '1') return;
        io.observe(el);
      });

      // First paint: IO often reports later; process pending records, then a layout-stable fallback.
      requestAnimationFrame(() => {
        if (typeof io.takeRecords === 'function') {
          for (const entry of io.takeRecords()) {
            if (entry.isIntersecting) tryStartCounter(entry.target);
          }
        }
        requestAnimationFrame(() => {
          els.forEach((el) => {
            if (d2cSistCounterIsAlreadyRevealed(el)) tryStartCounter(el);
          });
        });
      });
    }

    function bind(sectionEl) {
      if (sectionEl.hasAttribute('data-d2c-sist-init')) return;
      sectionEl.setAttribute('data-d2c-sist-init', '');

      syncD2cSistDesktopAside(sectionEl);
      initD2cSistCounterAnimations(sectionEl);

      const run = () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          syncD2cSistDesktopAside(sectionEl);
        }
        if (!window.matchMedia('(min-width: 768px)').matches) {
          const assets = Array.from(SEL_ALL(sectionEl, '[data-sist-asset]'));
          assets.forEach((a) => a.classList.remove('is-active'));
          if (assets[0]) assets[0].classList.add('is-active');
          return;
        }
        updateSection(sectionEl);
      };

      run();
      window.addEventListener('scroll', run, { passive: true });
      window.addEventListener('resize', run);
    }

    document.querySelectorAll('[data-d2c-sist]').forEach((s) => bind(s));
  })();

  } catch(e) { console.error(e); }
})();
})();
